import leafNumberReducer from './slices/leafNumber';
const rootReducer = {
  leafNumberReducer,
};
export default rootReducer;
